import {createSelector} from 'reselect'
import {setForm, formsSelector, getState} from '../store.js'
import {hasUseReturnOrdersFeatureSelector} from './company.js'

export const SERVER_INFO = 'server_info'

export function serverInfoSelector(state) {
  return formsSelector(state)[SERVER_INFO] || serverInfoSelector.default
}
serverInfoSelector.default = {
  version: null,
  needsAppReload: false,
}

export const needsAppReloadSelector = createSelector(
  serverInfoSelector,
  ({needsAppReload}) => needsAppReload,
)

export function setServerInfo(serverInfo) {
  setForm(SERVER_INFO, serverInfo)
}

export async function getServerInfo() {
  if (!hasUseReturnOrdersFeatureSelector(getState())) {
    return
  }

  const res = await fetch('/info.json', {method: 'GET'})

  const serverInfo = serverInfoSelector(getState())

  const newServerInfo = await res.json()

  if (serverInfo.version && serverInfo.version !== newServerInfo.version) {
    setServerInfo({
      ...serverInfo,
      version: newServerInfo.version,
      needsAppReload: true,
    })
  } else {
    setServerInfo({
      ...serverInfo,
      version: newServerInfo.version,
    })
  }
}
